import { createFileRoute } from '@tanstack/react-router'

import { CreateNotePage } from '@/components/organisms/notes/create-note-page'

/**
 * Adding a note from an errand. Renders the exact same form as /notes/new — the errand only
 * changes what the note attaches to and where the page returns to, both handled from `errandId`.
 *
 * The `$id_` suffix un-nests this from the `/errands/$id` route: that route is the errand detail
 * page, not a layout, so nesting under it would render the detail page and never reach this one.
 */
const ErrandNewNoteRoute = () => {
  const { id } = Route.useParams()

  return <CreateNotePage errandId={id} />
}

export const Route = createFileRoute('/_authenticated/errands/$id_/notes/new')({
  component: ErrandNewNoteRoute,
})
